import { Typography } from '@mui/material';

const GenServicesList = ({ services, scope = 1 }) => {
  if (!services || !services.length) return null;
  return (
    <Typography variant="body2">
      {services
        .slice(0, scope)
        .map(service => service.name)
        .join(', ')}
      {services.length > scope && `, (${services.length - scope}+)`}
    </Typography>
  );
};

export default GenServicesList;
